import { SVGProps } from 'react';

export default function SoldOut(props: SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg {...props} width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M30 63.9633C29.0624 64.9007 27.7908 65.4273 26.465 65.4273C25.1392 65.4273 23.8677 64.9007 22.93 63.9633L5.00002 46.0367C4.53539 45.5723 4.16681 45.021 3.91533 44.4142C3.66386 43.8073 3.53442 43.1569 3.53442 42.5C3.53442 41.8431 3.66386 41.1927 3.91533 40.5858C4.16681 39.979 4.53539 39.4277 5.00002 38.9633L40 3.96333C40.4645 3.49911 41.016 3.13094 41.6228 2.87986C42.2296 2.62878 42.88 2.4997 43.5367 2.5H61.4634C62.7894 2.5 64.0612 3.02678 64.9989 3.96447C65.9366 4.90215 66.4634 6.17392 66.4634 7.5V25.43C66.4631 26.7552 65.9368 28.026 65 28.9633'
        stroke='#FFDB01'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M53.9634 13.75C53.7162 13.75 53.4745 13.8233 53.2689 13.9607C53.0634 14.098 52.9031 14.2932 52.8085 14.5216C52.7139 14.7501 52.6892 15.0014 52.7374 15.2439C52.7856 15.4863 52.9047 15.7091 53.0795 15.8839C53.2543 16.0587 53.477 16.1778 53.7195 16.226C53.962 16.2742 54.2133 16.2495 54.4417 16.1548C54.6701 16.0602 54.8654 15.9 55.0027 15.6945C55.1401 15.4889 55.2134 15.2472 55.2134 15C55.2134 14.6685 55.0817 14.3505 54.8473 14.1161C54.6128 13.8817 54.2949 13.75 53.9634 13.75Z'
        stroke='#FFDB01'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M56.4634 77.5C67.5091 77.5 76.4634 68.5457 76.4634 57.5C76.4634 46.4543 67.5091 37.5 56.4634 37.5C45.4177 37.5 36.4634 46.4543 36.4634 57.5C36.4634 68.5457 45.4177 77.5 56.4634 77.5Z'
        stroke='#FFDB01'
        strokeWidth='5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path d='M63.9634 50L48.9634 65' stroke='#FFDB01' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
      <path d='M48.9634 50L63.9634 65' stroke='#FFDB01' strokeWidth='5' strokeLinecap='round' strokeLinejoin='round' />
    </svg>
  );
}
